module.exports = __webpack_public_path__ + "src/img/icon/icon_warn.6c47a3f9e222718ffe800e186d5cf66a.png";